// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import md5 from 'js-md5'
import {
    post
} from './utils/http';
import {
    config
} from './utils/config';
import pages from './common/mine/pages.vue';
import selectPages from './common/mine/selectPages.vue';
import submitBtn from './common/mine/submitBtn.vue';
import global from './utils/global.js';
// 引入选择城市
import CityChangeCheckbox from "@/utils/cityChangeCheckbox.vue";

// 引入导出表格数据方法
import exportTable from '@/utils/exportTable.js'
//引入上传图片方法
import uploadImage from '@/utils/uploadImage.js'
Vue.prototype.$uploadImage = uploadImage;

// 导出表格数据全局方法
Vue.prototype.$exportTable = exportTable;

Vue.prototype.global = global;


window.configSet = config; // 区分九州代驾还是马上代驾


Vue.use(ElementUI);


Vue.component("pages", pages);
Vue.component("selectPages", selectPages);
Vue.component("submitBtn", submitBtn);
Vue.component("CityChangeCheckbox", CityChangeCheckbox);


Vue.prototype.config = config;


//地图，三级联动声明      围栏功能
AMap.plugin(['AMap.DistrictSearch', 'AMap.PolyEditor']);
Vue.config.productionTip = false

// 定义全局方法-------拼接socket链接地址
Vue.prototype.$getSocketUrl = function() {


    var socket_url = config.webSocket + 'port=administrator&platform=pc&hash_key=' + this.$hash_key() + '&token=' + localStorage.getItem('token') + '&city_tag=' + JSON.parse(localStorage.getItem('city_tag')).city_tag + '&service_tag=' + localStorage.getItem('service_tag');

    return socket_url;


};


Vue.prototype.$hash_key = function(mode = 'none') {


    //hash创造

    var time = Math.round(new Date() / 1000) + Number(sessionStorage.getItem('time_difference'));


    time = time.toString();


    var hash = md5(md5(time + config.hash_key));


    var num1 = Math.ceil(Math.random() * 9);
    var num2 = Math.ceil(Math.random() * 9);
    var num3 = Math.ceil(Math.random() * 9);
    var num4 = Math.ceil(Math.random() * 9);

    var str = num1.toString() + num2.toString() + num3.toString() + num4.toString() + time.slice(-2, -1) + time.slice(-1) + hash.slice(num1, num1 + 1) + hash.slice(num2, num2 + 1) + hash.slice(num3, num3 + 1) + hash.slice(num4, num4 + 1);


    return str;


};

Vue.prototype.$post = post;

// 路由守卫
router.beforeEach((to, from, next) => {

    // sessionStorage.setItem("getDriverInsurance", 0);

    if (to.meta.requireAuth) { // 判断该路由是否需要登录权限

        if (localStorage.getItem('token') != null) { // 判断本地是否存在token

            next()
        } else {
            // 未登录,跳转到登陆页面
            next({
                path: '/Login'

            })
        }
    } else {


        next();


    }
});






/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js